import React from 'react';
import { useHistory } from 'react-router-dom';
import { Card, CardActionArea, Typography } from '@material-ui/core';
import ContactMailOutlinedIcon from '@material-ui/icons/ContactMailOutlined';
import CardTitle from '../../../common/card/CardTitle';
import CardContent from '../../../common/card/CardContent';
import { BaseSupplierCardProps } from '../Supplier.interface';

const SupplierContactCard: React.FC<BaseSupplierCardProps> = (
  props: BaseSupplierCardProps
) => {
  const history = useHistory();
  const { supplier } = props;
  return (
    <Card>
      <CardTitle>
        <ContactMailOutlinedIcon />
        Customer Info
      </CardTitle>
      <CardContent
        padding='small'
        onClick={() =>
          history.push(`/portal/suppliers/task/${supplier.taskId}/info`)
        }
      >
        <CardActionArea>
          <Typography>{supplier.companyName} </Typography>
          <Typography>{supplier.contactName} </Typography>
          <Typography>{supplier.phoneNumber} </Typography>
          <Typography>{supplier.address} </Typography>
        </CardActionArea>
      </CardContent>
    </Card>
  );
};

export default SupplierContactCard;
